import { render } from "./LoginLayout.vue?vue&type=template&id=60e9f479&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./LoginLayout.vue?vue&type=style&index=0&id=60e9f479&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e9f479"]])

export default __exports__